import i18n from "i18next";
import { initReactI18next } from "react-i18next";

export const LANGUAGES = [
  { code: "en", label: "English",    flag: "🇬🇧", dir: "ltr" },
  { code: "fr", label: "Français",   flag: "🇫🇷", dir: "ltr" },
  { code: "es", label: "Español",    flag: "🇪🇸", dir: "ltr" },
  { code: "it", label: "Italiano",   flag: "🇮🇹", dir: "ltr" },
  { code: "de", label: "Deutsch",    flag: "🇩🇪", dir: "ltr" },
  { code: "pt", label: "Português",  flag: "🇵🇹", dir: "ltr" },
  { code: "nl", label: "Nederlands", flag: "🇳🇱", dir: "ltr" },
  { code: "sv", label: "Svenska",    flag: "🇸🇪", dir: "ltr" },
  { code: "ar", label: "العربية",    flag: "🇸🇦", dir: "rtl" },
];

import en from "./locales/en.json";
import fr from "./locales/fr.json";
import es from "./locales/es.json";
import it from "./locales/it.json";
import de from "./locales/de.json";
import pt from "./locales/pt.json";
import nl from "./locales/nl.json";
import sv from "./locales/sv.json";
import ar from "./locales/ar.json";

const STORAGE_KEY = "tanta.lang";

i18n
  .use(initReactI18next)
  .init({
    resources: { en: { t: en }, fr: { t: fr }, es: { t: es }, it: { t: it }, de: { t: de }, pt: { t: pt }, nl: { t: nl }, sv: { t: sv }, ar: { t: ar } },
    lng: localStorage.getItem(STORAGE_KEY) || "en",
    fallbackLng: "en",
    defaultNS: "t",
    interpolation: { escapeValue: false },
    returnEmptyString: false,
  });

applyDirection(i18n.language);

export function changeLanguage(code) {
  i18n.changeLanguage(code);
  localStorage.setItem(STORAGE_KEY, code);
  applyDirection(code);
  // Best-effort: persist on server so backend-rendered notifications + emails
  // honour the user's choice. Silent failure for logged-out users.
  try {
    // Lazy import to avoid circular deps (api.js imports from elsewhere)
    import("@/lib/api").then(({ default: api }) => {
      api.post("/users/me/lang", { lang: code }).catch(() => {});
    }).catch(() => {});
  } catch (_) { /* noop */ }
}

function applyDirection(code) {
  const lang = LANGUAGES.find((l) => l.code === code) || LANGUAGES[0];
  if (typeof document !== "undefined") {
    document.documentElement.lang = code;
    document.documentElement.dir = lang.dir;
  }
}

export default i18n;
